import axios from "axios";
import SideNavbar from "../../../components/common/SideNavbar";
import TopNavbar from "../../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { userTableCustomStyles } from "../../../utils/TableCustomStyles";

function ProductMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [productPartData, setProductPartData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [portData, setPortData] = useState([]);
  const [depotData, setDepotData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteProductPartModal, setShowDeleteProductPartModal] =
    useState(false);
  const user_role = sessionStorage["userrole"];
  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  // Canvas visibility
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);
  const [canvasAddFullScreen, setCanvasAddFullScreen] = useState(false);
  const [canvasUpdateFullScreen, setCanvasUpdateFullScreen] = useState(false);

  // Loaders
  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [showDeleteProductPartLoader, setShowDeleteProductPartLoader] =
    useState(false);
  const [showUpdatePartLoader, setShowUpdatePartLoader] = useState(false);

  const [recordForDelete, setRecordForDelete] = useState(null);
  const [recordProductPartForDelete, setRecordProductPartForDelete] =
    useState(null);

  // ---------- Add form state (Product) ----------
  const [addProductName, setAddProductName] = useState("");
  const [addProductType, setAddProductType] = useState("CONTAINER");
  const [addNotes, setAddNotes] = useState("");
  const [addStatus, setAddStatus] = useState("ACTIVE");

  // Add field errors
  const [showProductNameError, setShowProductNameError] = useState(false);

  // Add validation summary
  const [showValidationError, setShowValidationError] = useState(false);
  const [validationErrorArray, setValidationErrorArray] = useState([]);
  const [isValidationErrorVisible, setIsValidationErrorVisible] =
    useState(false);

  // ---------- Update form state (Product) ----------
  const [updateId, setUpdateId] = useState("");
  const [updateProductName, setUpdateProductName] = useState("");
  const [updateProductType, setUpdateProductType] = useState("");
  const [updateNotes, setUpdateNotes] = useState("");
  const [updateStatus, setUpdateStatus] = useState("");

  // Update field errors
  const [showUpdateProductNameError, setShowUpdateProductNameError] =
    useState(false);

  // Update validation summary
  const [showUpdateValidationError, setShowUpdateValidationError] =
    useState(false);
  const [updateValidationErrorArray, setUpdateValidationErrorArray] = useState(
    [],
  );
  const [isUpdateValidationErrorVisible, setIsUpdateValidationErrorVisible] =
    useState(false);

  // ---------- Product Part form state ----------
  const [partId, setPartId] = useState(""); // for update (if empty => add)
  const [partName, setPartName] = useState("");
  const [partCountry, setPartCountry] = useState("");
  const [partPort, setPartPort] = useState(""); // selected port
  const [partDepot, setPartDepot] = useState("");
  const [partDescription, setPartDescription] = useState("");
  const [partLcms, setPartLcms] = useState("");
  const [partBcms, setPartBcms] = useState("");
  const [partLabourRate, setPartLabourRate] = useState("");
  const [partLabourHours, setPartLabourHours] = useState("");
  const [partTotalLabourRate, setPartTotalLabourRate] = useState("");
  const [partMaterialCost, setPartMaterialCost] = useState("");
  const [partTotalCost, setPartTotalCost] = useState("");

  // Part field errors
  const [showPartNameError, setShowPartNameError] = useState(false);
  const [showPartCountryError, setShowPartCountryError] = useState(false);
  const [showPartDepotError, setShowPartDepotError] = useState(false);
  const [showPartLcmsError, setShowPartLcmsError] = useState(false);
  const [showPartBcmsError, setShowPartBcmsError] = useState(false);
  const [showPartLabourRateError, setShowPartLabourRateError] = useState(false);
  const [showPartLabourHoursError, setShowPartLabourHoursError] =
    useState(false);
  const [showPartTotalLabourRateError, setShowPartTotalLabourRateError] =
    useState(false);
  const [showPartMaterialCostError, setShowPartMaterialCostError] =
    useState(false);
  const [showPartTotalCostError, setShowPartTotalCostError] = useState(false);
  // Description is optional, no error.

  // Part validation summary
  const [showPartValidationError, setShowPartValidationError] = useState(false);
  const [partValidationErrorArray, setPartValidationErrorArray] = useState([]);
  const [isPartValidationErrorVisible, setIsPartValidationErrorVisible] =
    useState(false);

  // Tabs for update canvas
  const [showUpdateProductDetails, setShowUpdateProductDetails] =
    useState(true);
  const [showUpdateProductPartDetails, setShowUpdateProductPartDetails] =
    useState(false);

  // ========== Validation Helpers ==========
  const isNumeric = (val) => /^\d*\.?\d+$/.test(val); // allows decimals

  // ========== Real‑time error helpers for Product Add ==========
  const hasAnyAddError = () => showProductNameError;

  const buildAddErrorMessages = () => {
    const errors = [];
    if (!addProductName) errors.push("Product Name is required");
    return errors;
  };

  // ========== Real‑time error helpers for Product Update ==========
  const hasAnyUpdateError = () => showUpdateProductNameError;

  const buildUpdateErrorMessages = () => {
    const errors = [];
    if (!updateProductName) errors.push("Product Name is required");
    return errors;
  };

  // ========== Real‑time error helpers for Product Part ==========
  const hasAnyPartError = () => {
    return (
      showPartNameError ||
      showPartCountryError ||
      showPartDepotError ||
      showPartLcmsError ||
      showPartBcmsError ||
      showPartLabourRateError ||
      showPartLabourHoursError ||
      showPartTotalLabourRateError ||
      showPartMaterialCostError ||
      showPartTotalCostError
    );
  };

  const buildPartErrorMessages = () => {
    const errors = [];
    if (!partName) errors.push("Part Name is required");
    if (!partCountry) errors.push("Country is required");
    if (!partDepot) errors.push("Depot is required");
    if (!partLcms) errors.push("L cms is required");
    else if (!isNumeric(partLcms)) errors.push("L cms must be a valid number");
    if (!partBcms) errors.push("B cms is required");
    else if (!isNumeric(partBcms)) errors.push("B cms must be a valid number");
    if (!partLabourRate) errors.push("Labour Rate is required");
    else if (!isNumeric(partLabourRate))
      errors.push("Labour Rate must be a valid number");
    if (!partLabourHours) errors.push("Labour Hours is required");
    else if (!isNumeric(partLabourHours))
      errors.push("Labour Hours must be a valid number");
    if (!partTotalLabourRate) errors.push("Total Labour Rate is required");
    else if (!isNumeric(partTotalLabourRate))
      errors.push("Total Labour Rate must be a valid number");
    if (!partMaterialCost) errors.push("Material Cost is required");
    else if (!isNumeric(partMaterialCost))
      errors.push("Material Cost must be a valid number");
    if (!partTotalCost) errors.push("Total Cost is required");
    else if (!isNumeric(partTotalCost))
      errors.push("Total Cost must be a valid number");
    return errors;
  };

  // Tooltip toggles
  const handleCheckValidationClick = () =>
    setIsValidationErrorVisible(!isValidationErrorVisible);
  const handleUpdateCheckValidationClick = () =>
    setIsUpdateValidationErrorVisible(!isUpdateValidationErrorVisible);
  const handlePartCheckValidationClick = () =>
    setIsPartValidationErrorVisible(!isPartValidationErrorVisible);

  // ========== API calls ==========
  const getLoggedInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      setLoggedInUser(response.data);
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getProduct = async () => {
    try {
      setDataPending(true);
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/product/",
      );
      setData(response.data);
    } catch (err) {
      toast.error("Error in fetching product data! Try again.");
    } finally {
      setDataPending(false);
    }
  };

  const getProductPart = async (product) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/productpart/getpartsbyproduct?product=" +
          product,
      );
      setProductPartData(response.data);
    } catch (err) {
      toast.error("Error in fetching product part data! Try again.");
    }
  };

  const getCountry = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/country/",
      );
      const sorted_data = response.data.sort(
        (a, b) => a.object_id - b.object_id,
      );
      setCountryData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching country data! Try again.");
    }
  };

  const getPort = async (country) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/port/getportbycountry?country=" +
          country,
      );
      const sorted_data = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setPortData(sorted_data);
      setPartPort(""); // Reset port when country changes
    } catch (err) {
      toast.error("Error in fetching port data! Try again.");
    }
  };

  const getDepot = async (port) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/depot/getdepotbyport?port=" +
          port,
      );
      const sorted_data = response.data.sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setDepotData(sorted_data);
    } catch (err) {
      toast.error("Error in fetching depot data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );
      const role_permissions_array = [];
      for (let i = 0; i < response.data?.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array?.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }
      setCurrentUserRolePermissionData(role_permissions_array);
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  useEffect(() => {
    getLoggedInUser();
    getProduct();
    getCountry();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  // ========== Delete handlers (Product) ==========
  const handleDeleteModalClose = () => setShowDeleteModal(false);
  const handleDeleteModalOpen = (data) => {
    setShowDeleteModal(true);
    setRecordForDelete(data);
  };

  const deleteSelectedRecord = async (id) => {
    setShowDeleteLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/product/" + id + "/",
      );
      setShowDeleteModal(false);
      getProduct();
      toast.success("Record deleted successfully");
    } catch (err) {
      toast.error("Error in deleting record! Try again.");
    }
    setShowDeleteLoader(false);
  };

  // ========== Add logic (Product) ==========
  const resetAddForm = () => {
    setAddProductName("");
    setAddProductType("CONTAINER");
    setAddNotes("");
    setAddStatus("ACTIVE");
    setShowProductNameError(false);
    setShowValidationError(false);
    setValidationErrorArray([]);
    setIsValidationErrorVisible(false);
  };

  const handleAddModalClose = () => {
    resetAddForm();
    setShowAddCanvas(false);
    setCanvasAddFullScreen(false);
  };

  const addNewProduct = async (e) => {
    e.preventDefault();

    setShowProductNameError(!addProductName);
    setValidationErrorArray(buildAddErrorMessages());

    if (!addProductName) {
      setShowValidationError(true);
      return;
    }

    setShowAddLoader(true);

    const payload = {
      product_name: addProductName,
      type: addProductType,
      notes: addNotes,
      status: addStatus,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.post(
        process.env.REACT_APP_BACKEND_API_URL + "/user/product/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Product Created Successfully");
        handleAddModalClose();
        getProduct();
      }
    } catch (err) {
      toast.error("Error creating product");
    } finally {
      setShowAddLoader(false);
    }
  };

  // ========== Update logic (Product) ==========
  const resetUpdateForm = () => {
    setUpdateId("");
    setUpdateProductName("");
    setUpdateProductType("");
    setUpdateNotes("");
    setUpdateStatus("");
    setShowUpdateProductNameError(false);
    setShowUpdateValidationError(false);
    setUpdateValidationErrorArray([]);
    setIsUpdateValidationErrorVisible(false);
    setProductPartData([]);
  };

  const handleUpdateModalClose = () => {
    resetUpdateForm();
    setShowUpdateCanvas(false);
    setCanvasUpdateFullScreen(false);
    setShowUpdateProductDetails(true);
    setShowUpdateProductPartDetails(false);
  };

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateProductName(row.product_name);
    setUpdateProductType(row.type);
    setUpdateNotes(row.notes);
    setUpdateStatus(row.status);
    getProductPart(row.id);
    // Reset part form when opening update
    resetPartForm();
  };

  const updateProduct = async (e) => {
    e.preventDefault();

    setShowUpdateProductNameError(!updateProductName);
    setUpdateValidationErrorArray(buildUpdateErrorMessages());

    if (!updateProductName) {
      setShowUpdateValidationError(true);
      return;
    }

    setShowUpdateLoader(true);

    const payload = {
      product_name: updateProductName,
      type: updateProductType,
      notes: updateNotes,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/product/" +
          updateId +
          "/",
        payload,
        { headers: { "content-type": "application/json" } },
      );
      if (response.status === 200) {
        toast.success("Product Updated Successfully");
        handleUpdateModalClose();
        getProduct();
      }
    } catch (err) {
      toast.error("Error updating product");
    } finally {
      setShowUpdateLoader(false);
    }
  };

  // ========== Product Part logic ==========
  const resetPartForm = () => {
    setPartId("");
    setPartName("");
    setPartCountry("");
    setPartPort("");
    setPartDepot("");
    setPartDescription("");
    setPartLcms("");
    setPartBcms("");
    setPartLabourRate("");
    setPartLabourHours("");
    setPartTotalLabourRate("");
    setPartMaterialCost("");
    setPartTotalCost("");
    setShowPartNameError(false);
    setShowPartCountryError(false);
    setShowPartDepotError(false);
    setShowPartLcmsError(false);
    setShowPartBcmsError(false);
    setShowPartLabourRateError(false);
    setShowPartLabourHoursError(false);
    setShowPartTotalLabourRateError(false);
    setShowPartMaterialCostError(false);
    setShowPartTotalCostError(false);
    setShowPartValidationError(false);
    setPartValidationErrorArray([]);
    setIsPartValidationErrorVisible(false);
    setPortData([]);
    setDepotData([]);
  };

  const handleSetUpdateProductPartData = (row) => {
    setPartId(row.id);
    setPartName(row.part_name);
    setPartCountry(row.country);
    getPort(row.country);
    setPartDepot(row.depot);
    setPartDescription(row.description);
    setPartLcms(row.l_cms);
    setPartBcms(row.b_cms);
    setPartLabourRate(row.labour_rate);
    setPartLabourHours(row.labour_hours);
    setPartTotalLabourRate(row.total_labour_rate);
    setPartMaterialCost(row.material_cost);
    setPartTotalCost(row.total_cost);
    // Reset errors
    setShowPartNameError(false);
    setShowPartCountryError(false);
    setShowPartDepotError(false);
    setShowPartLcmsError(false);
    setShowPartBcmsError(false);
    setShowPartLabourRateError(false);
    setShowPartLabourHoursError(false);
    setShowPartTotalLabourRateError(false);
    setShowPartMaterialCostError(false);
    setShowPartTotalCostError(false);
    setShowPartValidationError(false);
    setPartValidationErrorArray([]);
  };

  const updateProductPart = async (e) => {
    e.preventDefault();

    setShowPartNameError(!partName);
    setShowPartCountryError(!partCountry);
    setShowPartDepotError(!partDepot);
    setShowPartLcmsError(!partLcms || !isNumeric(partLcms));
    setShowPartBcmsError(!partBcms || !isNumeric(partBcms));
    setShowPartLabourRateError(!partLabourRate || !isNumeric(partLabourRate));
    setShowPartLabourHoursError(
      !partLabourHours || !isNumeric(partLabourHours),
    );
    setShowPartTotalLabourRateError(
      !partTotalLabourRate || !isNumeric(partTotalLabourRate),
    );
    setShowPartMaterialCostError(
      !partMaterialCost || !isNumeric(partMaterialCost),
    );
    setShowPartTotalCostError(!partTotalCost || !isNumeric(partTotalCost));
    setPartValidationErrorArray(buildPartErrorMessages());

    if (
      !partName ||
      !partCountry ||
      !partDepot ||
      !partLcms ||
      !partBcms ||
      !partLabourRate ||
      !partLabourHours ||
      !partTotalLabourRate ||
      !partMaterialCost ||
      !partTotalCost ||
      !isNumeric(partLcms) ||
      !isNumeric(partBcms) ||
      !isNumeric(partLabourRate) ||
      !isNumeric(partLabourHours) ||
      !isNumeric(partTotalLabourRate) ||
      !isNumeric(partMaterialCost) ||
      !isNumeric(partTotalCost)
    ) {
      setShowPartValidationError(true);
      return;
    }

    setShowUpdatePartLoader(true);

    const payload = {
      product: updateId,
      part_name: partName,
      country: partCountry,
      depot: partDepot,
      description: partDescription,
      l_cms: partLcms,
      b_cms: partBcms,
      labour_rate: partLabourRate,
      labour_hours: partLabourHours,
      total_labour_rate: partTotalLabourRate,
      material_cost: partMaterialCost,
      total_cost: partTotalCost,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    try {
      let response;
      if (partId) {
        // Update existing part
        response = await axios.put(
          process.env.REACT_APP_BACKEND_API_URL +
            "/user/productpart/" +
            partId +
            "/",
          payload,
          { headers: { "content-type": "application/json" } },
        );
      } else {
        // Create new part
        response = await axios.post(
          process.env.REACT_APP_BACKEND_API_URL + "/user/productpart/",
          payload,
          { headers: { "content-type": "application/json" } },
        );
      }

      if (response.status === 200 || response.status === 201) {
        toast.success(
          partId ? "Part Updated Successfully" : "Part Added Successfully",
        );
        resetPartForm();
        getProductPart(updateId);
      }
    } catch (err) {
      toast.error("Error saving part");
    } finally {
      setShowUpdatePartLoader(false);
    }
  };

  const handleDeleteProductPartModalClose = () =>
    setShowDeleteProductPartModal(false);
  const handleDeleteProductPartModalOpen = (data) => {
    setShowDeleteProductPartModal(true);
    setRecordProductPartForDelete(data);
  };

  const deleteSelectedProductPartRecord = async (id) => {
    setShowDeleteProductPartLoader(true);
    try {
      await axios.delete(
        process.env.REACT_APP_BACKEND_API_URL + "/user/productpart/" + id + "/",
      );
      setShowDeleteProductPartModal(false);
      getProductPart(updateId);
      toast.success("Part deleted successfully");
    } catch (err) {
      toast.error("Error deleting part");
    } finally {
      setShowDeleteProductPartLoader(false);
    }
  };

  // ========== Table columns ==========
  const columns = [
    {
      name: "Product Name",
      selector: (row) => row.product_name,
      sortable: true,
    },
    { name: "Type", selector: (row) => row.type, sortable: true },
    { name: "Notes", selector: (row) => row.notes, sortable: true },
    { name: "Status", selector: (row) => row.status, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:product:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => {
                handleSetUpdateData(row);
                setShowUpdateCanvas(true);
              }}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:product:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const productpartcolumns = [
    { name: "Name", selector: (row) => row.part_name, sortable: true },
    {
      name: "Country",
      selector: (row) => row.country_data?.long_name,
      sortable: true,
    },
    { name: "Depot", selector: (row) => row.depot_data?.name, sortable: true },
    { name: "Description", selector: (row) => row.description, sortable: true },
    { name: "L cms", selector: (row) => row.l_cms, sortable: true },
    { name: "B cms", selector: (row) => row.b_cms, sortable: true },
    { name: "Labour Rate", selector: (row) => row.labour_rate, sortable: true },
    {
      name: "Labour Hours",
      selector: (row) => row.labour_hours,
      sortable: true,
    },
    {
      name: "Total Labour Rate",
      selector: (row) => row.total_labour_rate,
      sortable: true,
    },
    {
      name: "Material Cost",
      selector: (row) => row.material_cost,
      sortable: true,
    },
    { name: "Total Cost", selector: (row) => row.total_cost, sortable: true },
    {
      name: "Action",
      center: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:product:update") && (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              onClick={() => handleSetUpdateProductPartData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          )}
          {currentUserRolePermissionData?.includes("master:product:delete") && (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteProductPartModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          )}
        </div>
      ),
    },
  ];

  const handleDataFromTopNavBar = (permissiondata) =>
    setDataFromTopNavBar(permissiondata);

  return (
    <div className="page-content-bg">
      <ToastContainer />
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="AdminMaster"
        activeSubMenuLevel1="ProductMaster"
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Product Master</span>
            </div>
            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes("master:product:add") ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0 px-3 float-right"
                  onClick={() => {
                    resetAddForm();
                    setShowAddCanvas(true);
                  }}
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Product</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={userTableCustomStyles}
            dense
          />
        </div>
      </div>

      {/* Delete Modal (Product) */}
      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() => deleteSelectedRecord(recordForDelete?.id)}
          >
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal (Product Part) */}
      <Modal
        size="sm"
        show={showDeleteProductPartModal}
        onHide={handleDeleteProductPartModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Part</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this part?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleDeleteProductPartModalClose}
          >
            Close
          </Button>
          <Button
            variant="danger"
            onClick={() =>
              deleteSelectedProductPartRecord(recordProductPartForDelete?.id)
            }
          >
            {showDeleteProductPartLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Canvas ------------------- */}
      <div
        className={
          canvasUpdateFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasUpdateFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="updateCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-5">
              <h4 id="updateCanvasLabel" className="float-left">
                Update Record{" "}
                <small className="font-12px">({updateProductName})</small>
              </h4>
              <Button
                className={`${showUpdateProductDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateProductDetails(true);
                  setShowUpdateProductPartDetails(false);
                }}
              >
                Details
              </Button>
              <Button
                className={`${showUpdateProductPartDetails ? "btn-inox-red" : "btn-inox-green"} border-0 btn-sm`}
                style={{ marginRight: 10, width: 120 }}
                onClick={() => {
                  setShowUpdateProductDetails(false);
                  setShowUpdateProductPartDetails(true);
                }}
              >
                Parts
              </Button>
            </div>
            <div className="col-7">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleUpdateModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasUpdateFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasUpdateFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasUpdateFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          {/* Product Details Tab */}
          {showUpdateProductDetails && (
            <form onSubmit={updateProduct}>
              <div className="row">
                {/* Product Name */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label
                    className="required-label"
                    htmlFor="update_product_name"
                  >
                    Product Name:
                    <span className="text-danger">
                      {showUpdateProductNameError
                        ? " Product Name required"
                        : ""}
                    </span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_product_name"
                    placeholder="Enter Product Name"
                    value={updateProductName}
                    onChange={(e) => {
                      setUpdateProductName(e.target.value);
                      setShowUpdateProductNameError(false);
                      setShowUpdateValidationError(false);
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                    onBlur={(e) => {
                      setShowUpdateProductNameError(e.target.value === "");
                      setUpdateValidationErrorArray(buildUpdateErrorMessages());
                    }}
                  />
                </div>

                {/* Type */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_type">Type:</label>
                  <select
                    className="form-select form-select-sm"
                    id="update_type"
                    value={updateProductType}
                    onChange={(e) => setUpdateProductType(e.target.value)}
                  >
                    <option value="CONTAINER">CONTAINER</option>
                    <option value="BL">BL</option>
                    <option value="OTHER">OTHER</option>
                  </select>
                </div>

                {/* Notes */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_notes">Notes:</label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="update_notes"
                    placeholder="Enter Notes"
                    value={updateNotes}
                    onChange={(e) => setUpdateNotes(e.target.value)}
                  />
                </div>

                {/* Status */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                >
                  <label htmlFor="update_status">Status:</label>
                  <select
                    className="form-select form-select-sm"
                    id="update_status"
                    value={updateStatus}
                    onChange={(e) => setUpdateStatus(e.target.value)}
                  >
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>

                {/* Submit Button + Error Tooltip */}
                <div
                  className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
                >
                  <div className="canvas-btn-row">
                    <Button
                      type="submit"
                      className="btn btn-inox-green border-0 canvas-button"
                      disabled={hasAnyUpdateError() || showUpdateLoader}
                    >
                      {showUpdateLoader ? (
                        <Spinner
                          className="mx-4"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        <>
                          <i className="fa fa-edit"></i>{" "}
                          <span className="mx-2">Update</span>
                        </>
                      )}
                    </Button>

                    {(hasAnyUpdateError() || showUpdateValidationError) && (
                      <div className="error-tooltip-wrapper">
                        <Button
                          style={{
                            backgroundColor: "#C21E22",
                            border: "#f82e2e",
                          }}
                          title="Show Errors"
                          className="mx-2"
                          onClick={handleUpdateCheckValidationClick}
                          onMouseLeave={() =>
                            setIsUpdateValidationErrorVisible(false)
                          }
                        >
                          <i className="fa fa-exclamation"></i>
                        </Button>
                        {isUpdateValidationErrorVisible && (
                          <div className="validation-error-tooltip">
                            <ul className="mb-0 px-4">
                              {updateValidationErrorArray.map(
                                (error, index) => (
                                  <li
                                    key={index}
                                    className="text-left small pb-0"
                                  >
                                    {error}
                                  </li>
                                ),
                              )}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          )}

          {/* Product Parts Tab */}
          {showUpdateProductPartDetails && (
            <div>
              <form onSubmit={updateProductPart}>
                <div className="row">
                  {/* Part Name */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_name">
                      Part Name:
                      <span className="text-danger">
                        {showPartNameError ? (partName ? " Required" : "") : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_name"
                      placeholder="Enter Part Name"
                      value={partName}
                      onChange={(e) => {
                        setPartName(e.target.value);
                        setShowPartNameError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowPartNameError(e.target.value === "");
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Country */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_country">
                      Country:
                      <span className="text-danger">
                        {showPartCountryError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-control-sm"
                      id="part_country"
                      value={partCountry}
                      onChange={(e) => {
                        setPartCountry(e.target.value);
                        getPort(e.target.value);
                        setShowPartCountryError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowPartCountryError(e.target.value === "");
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    >
                      <option value="">Select Country</option>
                      {countryData.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.long_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Port */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="part_port">Port:</label>
                    <select
                      className="form-select form-control-sm"
                      id="part_port"
                      value={partPort}
                      onChange={(e) => {
                        setPartPort(e.target.value);
                        getDepot(e.target.value);
                      }}
                    >
                      <option value="">Select Port</option>
                      {portData.map((port) => (
                        <option key={port.id} value={port.id}>
                          {port.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Depot */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_depot">
                      Depot:
                      <span className="text-danger">
                        {showPartDepotError ? " Required" : ""}
                      </span>
                    </label>
                    <select
                      className="form-select form-control-sm"
                      id="part_depot"
                      value={partDepot}
                      onChange={(e) => {
                        setPartDepot(e.target.value);
                        setShowPartDepotError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        setShowPartDepotError(e.target.value === "");
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    >
                      <option value="">Select Depot</option>
                      {depotData.map((depot) => (
                        <option key={depot.id} value={depot.id}>
                          {depot.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Description */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label htmlFor="part_description">Description:</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_description"
                      placeholder="Enter Description"
                      value={partDescription}
                      onChange={(e) => setPartDescription(e.target.value)}
                    />
                  </div>

                  {/* L cms */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_lcms">
                      L cms:
                      <span className="text-danger">
                        {showPartLcmsError
                          ? partLcms
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_lcms"
                      placeholder="Enter L cms"
                      value={partLcms}
                      onChange={(e) => {
                        setPartLcms(e.target.value);
                        setShowPartLcmsError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartLcmsError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* B cms */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_bcms">
                      B cms:
                      <span className="text-danger">
                        {showPartBcmsError
                          ? partBcms
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_bcms"
                      placeholder="Enter B cms"
                      value={partBcms}
                      onChange={(e) => {
                        setPartBcms(e.target.value);
                        setShowPartBcmsError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartBcmsError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Labour Rate */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="part_labour_rate"
                    >
                      Labour Rate:
                      <span className="text-danger">
                        {showPartLabourRateError
                          ? partLabourRate
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_labour_rate"
                      placeholder="Enter Labour Rate"
                      value={partLabourRate}
                      onChange={(e) => {
                        setPartLabourRate(e.target.value);
                        setShowPartLabourRateError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartLabourRateError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Labour Hours */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="part_labour_hours"
                    >
                      Labour Hours:
                      <span className="text-danger">
                        {showPartLabourHoursError
                          ? partLabourHours
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_labour_hours"
                      placeholder="Enter Labour Hours"
                      value={partLabourHours}
                      onChange={(e) => {
                        setPartLabourHours(e.target.value);
                        setShowPartLabourHoursError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartLabourHoursError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Total Labour Rate */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="part_total_labour_rate"
                    >
                      Total Labour Rate:
                      <span className="text-danger">
                        {showPartTotalLabourRateError
                          ? partTotalLabourRate
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_total_labour_rate"
                      placeholder="Enter Total Labour Rate"
                      value={partTotalLabourRate}
                      onChange={(e) => {
                        setPartTotalLabourRate(e.target.value);
                        setShowPartTotalLabourRateError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartTotalLabourRateError(
                          !val || !isNumeric(val),
                        );
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Material Cost */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label
                      className="required-label"
                      htmlFor="part_material_cost"
                    >
                      Material Cost:
                      <span className="text-danger">
                        {showPartMaterialCostError
                          ? partMaterialCost
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_material_cost"
                      placeholder="Enter Material Cost"
                      value={partMaterialCost}
                      onChange={(e) => {
                        setPartMaterialCost(e.target.value);
                        setShowPartMaterialCostError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartMaterialCostError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Total Cost */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
                  >
                    <label className="required-label" htmlFor="part_total_cost">
                      Total Cost:
                      <span className="text-danger">
                        {showPartTotalCostError
                          ? partTotalCost
                            ? " Must be a valid number"
                            : " Required"
                          : ""}
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      id="part_total_cost"
                      placeholder="Enter Total Cost"
                      value={partTotalCost}
                      onChange={(e) => {
                        setPartTotalCost(e.target.value);
                        setShowPartTotalCostError(false);
                        setShowPartValidationError(false);
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        setShowPartTotalCostError(!val || !isNumeric(val));
                        setPartValidationErrorArray(buildPartErrorMessages());
                      }}
                    />
                  </div>

                  {/* Submit Button + Error Tooltip for Part */}
                  <div
                    className={`form-group ${canvasUpdateFullScreen ? "col-md-12" : "col-md-12"}`}
                  >
                    <div className="canvas-btn-row">
                      <Button
                        type="submit"
                        className="btn btn-inox-green border-0 canvas-button"
                        disabled={hasAnyPartError() || showUpdatePartLoader}
                      >
                        {showUpdatePartLoader ? (
                          <Spinner
                            className="mx-4"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          <>
                            {partId ? (
                              <>
                                <i className="fa fa-edit"></i>{" "}
                                <span className="mx-2">Update Part</span>
                              </>
                            ) : (
                              <>
                                <i className="fa fa-plus"></i>{" "}
                                <span className="mx-2">Add Part</span>
                              </>
                            )}
                          </>
                        )}
                      </Button>

                      {(hasAnyPartError() || showPartValidationError) && (
                        <div className="error-tooltip-wrapper">
                          <Button
                            style={{
                              backgroundColor: "#C21E22",
                              border: "#f82e2e",
                            }}
                            title="Show Errors"
                            className="mx-2"
                            onClick={handlePartCheckValidationClick}
                            onMouseLeave={() =>
                              setIsPartValidationErrorVisible(false)
                            }
                          >
                            <i className="fa fa-exclamation"></i>
                          </Button>
                          {isPartValidationErrorVisible && (
                            <div className="validation-error-tooltip">
                              <ul className="mb-0 px-4">
                                {partValidationErrorArray.map(
                                  (error, index) => (
                                    <li
                                      key={index}
                                      className="text-left small pb-0"
                                    >
                                      {error}
                                    </li>
                                  ),
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </form>

              <div
                className="col-12 text-left"
                style={{ marginTop: 20, paddingLeft: 0, paddingRight: 0 }}
              >
                <DataTable
                  columns={productpartcolumns}
                  data={productPartData}
                  progressPending={dataPending}
                  progressComponent={
                    <Spinner
                      className="mx-5 text-inox-green table-spinner"
                      as="span"
                      animation="border"
                      size="lg"
                      role="status"
                      aria-hidden="true"
                    />
                  }
                  noDataComponent={
                    <p className="text-center table-no-data">No Parts Found</p>
                  }
                  pagination
                  highlightOnHover
                  fixedHeader
                  customStyles={userTableCustomStyles}
                  dense
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ------------------------ Add Canvas ------------------- */}
      <div
        className={
          canvasAddFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasAddFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-50 show"
              : "offcanvas offcanvas-bottom h-50"
        }
        tabIndex="-1"
        aria-labelledby="addCanvasLabel"
      >
        <div className="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="addCanvasLabel" className="float-left">
                Add New Product
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-danger btn-sm float-right"
                aria-label="Close"
                title="Close"
                onClick={handleAddModalClose}
              >
                <i className="fa fa-times text-white"></i>
              </button>
              {canvasAddFullScreen ? (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => setCanvasAddFullScreen(false)}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => setCanvasAddFullScreen(true)}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        <div
          className="offcanvas-body"
          style={{ paddingLeft: 20, paddingRight: 40 }}
        >
          <form onSubmit={addNewProduct}>
            <div className="row">
              {/* Product Name */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label className="required-label" htmlFor="add_product_name">
                  Product Name:
                  <span className="text-danger">
                    {showProductNameError ? " Product Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_product_name"
                  placeholder="Enter Product Name"
                  value={addProductName}
                  onChange={(e) => {
                    setAddProductName(e.target.value);
                    setShowProductNameError(false);
                    setShowValidationError(false);
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                  onBlur={(e) => {
                    setShowProductNameError(e.target.value === "");
                    setValidationErrorArray(buildAddErrorMessages());
                  }}
                />
              </div>

              {/* Type */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_type">Type:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_type"
                  value={addProductType}
                  onChange={(e) => setAddProductType(e.target.value)}
                >
                  <option value="CONTAINER">CONTAINER</option>
                  <option value="BL">BL</option>
                  <option value="OTHER">OTHER</option>
                </select>
              </div>

              {/* Notes */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_notes">Notes:</label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="add_notes"
                  placeholder="Enter Notes"
                  value={addNotes}
                  onChange={(e) => setAddNotes(e.target.value)}
                />
              </div>

              {/* Status */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-2" : "col-md-2"} text-left mb-4`}
              >
                <label htmlFor="add_status">Status:</label>
                <select
                  className="form-select form-select-sm"
                  id="add_status"
                  value={addStatus}
                  onChange={(e) => setAddStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              {/* Submit Button + Error Tooltip */}
              <div
                className={`form-group ${canvasAddFullScreen ? "col-md-12" : "col-md-12"}`}
              >
                <div className="canvas-btn-row">
                  <Button
                    type="submit"
                    className="btn btn-inox-green border-0 canvas-button"
                    disabled={hasAnyAddError() || showAddLoader}
                  >
                    {showAddLoader ? (
                      <Spinner
                        className="mx-4"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="fa fa-plus"></i>{" "}
                        <span className="mx-2">Add</span>
                      </>
                    )}
                  </Button>

                  {(hasAnyAddError() || showValidationError) && (
                    <div className="error-tooltip-wrapper">
                      <Button
                        style={{
                          backgroundColor: "#C21E22",
                          border: "#f82e2e",
                        }}
                        title="Show Errors"
                        className="mx-2"
                        onClick={handleCheckValidationClick}
                        onMouseLeave={() => setIsValidationErrorVisible(false)}
                      >
                        <i className="fa fa-exclamation"></i>
                      </Button>
                      {isValidationErrorVisible && (
                        <div className="validation-error-tooltip">
                          <ul className="mb-0 px-4">
                            {validationErrorArray.map((error, index) => (
                              <li key={index} className="text-left small pb-0">
                                {error}
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProductMaster;
